import React, {useEffect, useState} from 'react'

import {getBrandHeaderLogoUrl} from '@vio/core/src/_web/brand/utils'
import {RouterAgnosticLink as Link} from '@vio/core/src/_web/router/components/RouterAgnosticLink'
import {Brand} from '@vio/core/src/brand/types'
import urls from '@vio/core/src/utils/url'

import {StyledLogo} from './styles'

const StyledLogoLink = StyledLogo.withComponent(Link)

interface Props {
  brand: Brand
  logoUrl?: string
  children: React.ReactNode
}

export const SearchTopBarLogoWrapper: React.FC<Props> = ({
  brand,
  logoUrl,
  children
}) => {
  const [brandLogoUrl, setBrandLogoUrl] = useState(logoUrl)

  useEffect(() => {
    // some partners want a custom logo url, so we check for that first
    setBrandLogoUrl(getBrandHeaderLogoUrl(brand, logoUrl))
  }, [brand, logoUrl])

  if (brandLogoUrl) {
    return (
      <StyledLogo data-id="BrandLogo" href={brandLogoUrl}>
        {children}
      </StyledLogo>
    )
  }

  return (
    <StyledLogoLink data-id="BrandLogo" to={urls.root}>
      {children}
    </StyledLogoLink>
  )
}
